<script>
	export let campaigns;
	import Campaign from './Campaign.svelte';
</script>

<svelte:head>
	<title>Tipey Joa | TWC-SD Invites Your Support</title>
</svelte:head>

<main>
	<h1 class="site-title">TWC-SD Invites Your Support</h1>
	<hr>
	{#each campaigns as campaign}
	<Campaign campaign={campaign}/>
	{/each}
</main>
<footer>
	<p>This page created by <a href="https://twcsandiego.org/">Tech Worker Coalition San Diego Chapter (TWC-SD)</a></p>
</footer>

<style>
	main {
		text-align: center;
		padding: 1em;
		max-width: 240px;
		margin: 0 auto;
		border-top: 5px solid #ee2543;
		max-width: none;
	}

	h1.site-title {
		color: #ee2543;
		font-size: 2.5em;
		font-weight: 400;
	}

	h4 {
		font-weight: 300;
		font-size: 1.1em;
		margin: 0 auto;
		max-width: 400px;
		margin-bottom: 1em;
	}
	hr {
		border-width: 0;
		background: #ddd;
		color: #ddd;
		height: 1px;
		margin: 30px 0;
	}
	footer {
		width: 100%;
		padding: 3em 0 5em;
		font-size: 0.9em;
		text-align: center;
		border-bottom: 5px solid #ee2543;
	}
	footer p {
		margin: 0px auto;
		color: #666;
		max-width: 50%;
	}


	@media (min-width: 640px) {
		main {
			max-width: none;
		}

		h1.site-title {
			font-size: 3em;
		}
	}

	@media (max-width: 640px) {
		h1.nothing {
			font-size: 1em !important;
		}
	}

</style>
